import { Badge, Tag } from 'antd';

import { USER_STATUS, USER_TYPE } from '@/constants';

export const UserTypeTag = ({ type }: { type: keyof typeof USER_TYPE }) => (
  <Tag color={type === 'ADMIN' ? 'red' : 'blue'}>{USER_TYPE[type]}</Tag>
);

export const UserStatusBadge = ({
  status,
}: {
  status: keyof typeof USER_STATUS;
}) => (
  <Badge
    status={status === 'ACTIVE' ? 'success' : 'default'}
    text={USER_STATUS[status] ?? status}
  />
);

/** 전체 지점 접근이면 ALL, 아니면 지점 수 */
export const BranchAccessLabel = ({
  hasAllBranchAccess,
  branchCount,
}: {
  hasAllBranchAccess: boolean;
  branchCount: number;
}) => <>{hasAllBranchAccess ? 'ALL' : `${branchCount}개`}</>;
